import { useQuery } from '@tanstack/react-query'
import { DEFAULT_LOCALE, type Locale } from '@diana/shared'
import { api } from '../lib/api.js'

/**
 * Everything the public site needs, in one request. One round trip instead
 * of five, so the homepage doesn't waterfall.
 */
export function useContent(locale: Locale = DEFAULT_LOCALE) {
  return useQuery({
    queryKey: ['content', locale],
    queryFn: () => api.content(locale),
  })
}
